import theme from '@ifca-root/react-component/src/assets/theme'
import { AccountFooter } from '@ifca-root/react-component/src/components/Footer/AccountFooter'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useMediaQuery } from '@material-ui/core'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useGetCompanyNameQuery,
  useGetCreditorAccountCompanyAssignmentNameLazyQuery,
  useGetInboundEInvoiceLazyQuery,
  useImportInboundInvoiceMutation,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router'
import { InboundAdvanceFilter } from './InboundAdvanceFilter'
import { InboundTable } from './InboundTable'

export const InboundEInvoice = (props: any) => {
  const { status } = props
  /* -------------------------------------------- */
  /*                VARIABLES                     */
  /* -------------------------------------------- */
  let history = useHistory()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()
  /* -------------------------------------------- */
  /*                    STATE                     */
  /* -------------------------------------------- */
  const { CompanyID }: any = useParams()
  const [errMsg, setErrMsg] = useState<string>('')
  const [docType, setDocType] = useState([])
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [selectedID, setSelectedID] = useState(new Set([]))

  /* -------------------------------------------- */
  /*                    QUERY                     */
  /* -------------------------------------------- */

  const [
    loadInboundEinvoice,
    {
      loading: InboundEinvoiceLoading,
      called: InboundEinvoiceCalled,
      data: { getInboundEInvoice } = {
        getInboundEInvoice: [],
      },
    },
  ] = useGetInboundEInvoiceLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ getInboundEInvoice }) => {
      if (getInboundEInvoice?.length > 0) {
        setOriginalListing([...filteredList, ...getInboundEInvoice])
      }
    },
  })

  const {
    loading: CompanyLoading,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onCompleted: ({ getCompany }) => {
      if (!!getCompany) {
        fetchCreditorAccountCompanyAssignment({
          variables: {
            CompanyID: CompanyID,
          },
        })
      }
    },
  })

  useEffect(() => {
    loadInboundEinvoice({
      variables: {
        CompanyID: CompanyID,
      },
    })
  }, [])

  const [
    fetchCreditorAccountCompanyAssignment,
    {
      loading: CreditorAccountCompanyAssignmentLoading,
      data: { getCreditorAccountCompanyAssignment } = {
        getCreditorAccountCompanyAssignment: [],
      },
    },
  ] = useGetCreditorAccountCompanyAssignmentNameLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  let creditorAcc = getCreditorAccountCompanyAssignment?.map(x => {
    return x?.CreditorAccount
  })

  const [
    importInboundInvoice,
    { loading: importInboundInvoiceLoading },
  ] = useImportInboundInvoiceMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      loadInboundEinvoice({ variables: { CompanyID: CompanyID } })
      setTimeout(() => {
        history.push({
          pathname: `/account-payable/${CompanyID}/inbound-einvoice`,
        })
      }, 500)
    },
  })
  /* -------------------------------------------- */
  /*                 MUTATION                     */
  /* -------------------------------------------- */

  /* ----------------------------------------- */
  /*                USE FORM                   */
  /* ----------------------------------------- */
  const {
    register: registerFilter,
    control: controlFilter,
    setValue: setValueFilter,
    getValues: getValueFilter,
    watch: watchFilter,
  } = useForm()

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */
  const footerOptions = [
    {
      disabled: !!(selectedID?.size === 0),
      name: `Import (${selectedID?.size})`,
      onClick: () => {
        onSubmit(selectedID)
      },
      color: 'primary',
      props: { type: 'submit' },
      style: { float: 'right', margin: isDesktop ? null : '0 auto' },
    },
  ]

  /* --------------------------------- */
  /*              ON SUBMIT            */
  /* --------------------------------- */
  let listIDs: any = Array.from(selectedID || [])
  const onSubmit = data => {
    importInboundInvoice({
      variables: {
        ap_transaction_id: listIDs,
      },
    })
  }

  return (
    <>
      {CompanyLoading && <Loading />}

      <InboundAdvanceFilter
        registerFilter={registerFilter}
        controlFilter={controlFilter}
        setValueFilter={setValueFilter}
        watchFilter={watchFilter}
        docType={docType}
        setDocType={setDocType}
        creditorAcc={creditorAcc}
      />
      <ContentWrapper footer>
        <InboundTable
          data={getInboundEInvoice}
          selectedID={selectedID}
          setSelectedID={setSelectedID}
          status={status}
        />
      </ContentWrapper>

      {status === 'pending' && (
        <AccountFooter
          optionStyle={{ float: isDesktop ? 'right' : null }}
          options={footerOptions}
        />
      )}
      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
